import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Grid,
  Box,
  Button,
  Link,
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const PopupDialog = ({
  isErrorDialogOpen,
  setIsErrorDialogOpen,
  isDeleted,
}) => {
  const handleCloseErrorDialog = () => {
    setIsErrorDialogOpen(false);
  };

  return (
    <Dialog
      open={isErrorDialogOpen}
      onClose={handleCloseErrorDialog}
      maxWidth='sm'
      className='locked-accounts'
    >
      <DialogTitle></DialogTitle>
      <DialogContent sx={{ color: '#000' }}>
        <Typography
          sx={{
            fontSize: '16px',
            fontWeight: 'bold',
            color: 'crimson',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <ErrorOutlineIcon sx={{ marginRight: 2 }} />{' '}
          {isDeleted
            ? 'Sorry, unable to switch to the account. This user is no longer available.'
            : 'Swap user account has been locked. Please reach out to your admin to get it unlocked.'}
        </Typography>
        <br />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseErrorDialog} color='primary'>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PopupDialog;
